import { path } from 'd3-path'
import Symbol2d from '../2d.js'

export default class Rectangle extends Symbol2d {

  path (dimensions, handles) {
    const _path = path()
    _path.moveTo(0, 0)
    _path.lineTo(dimensions.width, 0) // upper right
    _path.lineTo(dimensions.width, dimensions.height) // lower right
    _path.lineTo(0, dimensions.height) // lower left
    _path.lineTo(0, 0) // upper left
    _path.closePath()
    return _path.toString()
  }

}
